import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_MODIFIER_GROUP, EDIT_MODIFIER_GROUP } from './constants';

export const getModifierGroup = extendRoutine(createRoutine(GET_MODIFIER_GROUP), 'RESET');
export const editModifierGroup = extendRoutine(createRoutine(EDIT_MODIFIER_GROUP), 'RESET');
